import { FC, MouseEvent } from 'react'

import { Box, Button, darken, Divider, lighten } from '@mui/material'
import { ArrowDropDownIcon } from '@mui/x-date-pickers'

type MenuButtonProps = {
  onClick: (e: MouseEvent<HTMLButtonElement>) => void
  testId?: string
  open: boolean
  label: string
  variant?: 'contained' | 'outlined' | 'text'
}

export const MenuButton: FC<MenuButtonProps> = ({
  onClick,
  testId,
  label,
  open,
  variant = 'outlined'
}) => {
  return (
    <Button sx={{ pr: 1 }} variant={variant} onClick={onClick} size="medium" data-testid={testId}>
      <Box component="span" sx={{ pr: 1.15 }}>
        {label}
      </Box>
      <Divider
        orientation="vertical"
        sx={{
          mr: 0.6,
          height: 18,
          borderColor: ({ palette }) =>
            palette.mode === 'dark'
              ? darken(palette.primary.main, 0.2)
              : lighten(palette.primary.main, 0.5)
        }}
      />
      <ArrowDropDownIcon sx={{ rotate: open ? '180deg' : '0deg' }} />
    </Button>
  )
}
